import FetchHelper from '../helpers/fetch_helper';
import Constants from '../helpers/constants';

const FunctionalityAclsDispatcher = {
  async fetchFunctionalityAcls(userId) {
    try {
      this.acquireLock('fetchFunctionalityAcls');
      if (this.getStoreVal('isGuestUser')) {
        this.setStoreVal('userFunctionalityAcls', [
          {
            featureCode: Constants.FUNCTIONALITY_ACL_FEATURE_CODE_STEP4_ACCESS,
            dateCreated: '1970-01-01 00:00:00',
            id: -9999,
          },
        ]);
      } else {
        const response = await FetchHelper.fetchJson(`users/${userId}/functionality-acls`, { method: 'GET' });
        this.setStoreValWithCheck('userFunctionalityAcls', response.results);
      }
      this.decrementLock('fetchFunctionalityAcls');
    } catch (error) {
      this.dispatch({
        type: 'handleRequestError',
        data: { error, defaultErrorMessage: `Could not retrieve functionality ACLs for user ${userId}` },
      });
    }
  },
};

export default FunctionalityAclsDispatcher;
